import * as wasm from "./kdtree_fast_bg.wasm";
export * from "./kdtree_fast_bg.js";